import React, { Component } from "react";
import { Card, CardBody, Col, Row, CardTitle, Alert,Container,Button,Table,Badge,CardFooter,Modal,FormText } from "reactstrap";
import { AvForm, AvField,AvInput  } from 'availity-reactstrap-validation';
import {CustomPagination} from "../Common/CustomPagination";
import {DataTabeSearch} from '../Common/DataTabeSearch'
// Redux
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import AsyncSelect from "react-select/async";

//Import Breadcrumb
import Breadcrumbs from '../../../components/Common/Breadcrumb';
import { createExpenseType,expenseTypeList,editExpenseType} from '../../../store/expenseType/actions';
import { expenseGroupSearchList} from '../../../store/expenseGroupTypeMap/actions';
import { createExpenseGroup,expenseGroupList} from '../../../store/expenseGroup/actions';
 
class ExpenseTypes extends Component {
    constructor(props) {
        super(props);
        this.state = {
                page: 1,
                per_page: 10,
                search: '',
                customchk: true,
                toggleSwitch: false,
                edittoggleSwitch: false,  
                modal_scroll: false,
                expenseGroupList: [],  
                expenseType: {
                    
                }
            };
        // this.tog_scroll = this.tog_scroll.bind(this);
    }

    componentDidMount()
    {
        this.fetchexpenseTypeList();  
        this.fetchexpenseGroupList();  
    }

    
    fetchexpenseTypeList = () => {
        let options = {
            page: this.state.page,
            per_page: this.state.per_page,
            search: this.state.search
        }
        expenseTypeList(options).then((response) => {

            this.setState({
                expenseTypeList :response.data, 
            });
        })
        .catch((err) => {
            console.log(err);
        })
    }

    fetchexpenseGroupList = () => {
        let options = {
            page: this.state.page,
            per_page: 10,
            search: this.state.search
        }
        expenseGroupList(options).then((response) => {

            var item = [];

            response.data.data.forEach(element => {
                item.push({'label': element.expense_group_name, 'value': element.expense_group_id})
            });
            this.setState({
                expenseGroupList : item, 
            });
            
        })
        .catch((err) => {
            console.log(err);
        })
    }

    //modal
    tog_scroll = (expenseType) => {
        this.setState(prevState => ({
          modal_scroll: !prevState.modal_scroll,
        }));
        this.state.expenseType = expenseType;
        this.removeBodyCss();
      }

      removeBodyCss() {
        document.body.classList.add("no_padding");
      }

      // handleValidSubmit
        handleValidSubmit(event, values) {          
            this.props.createExpenseType(values);
            this.form && this.form.reset();
            this.fetchexpenseTypeList();     
        }

       
       handleEditSubmit(event, values) {  
            this.props.editExpenseType(values);
            this.setState(prevState => ({
                modal_scroll: !prevState.modal_scroll,
              }));

            this.fetchexpenseTypeList(); 
       }

       handleInputChange = (e) => {
        this.setState({[e.target.name]: e.target.value},() => {
            this.fetchexpenseTypeList();
        });
       }

       handlePageClick = (e, index) => {
            e.preventDefault()
            this.setState({
                page: index
            },() => {
                this.fetchexpenseTypeList();
            });
        }

        loadGroupOptions = (inputValue, callback) => {

            expenseGroupSearchList(inputValue).then((response) => {
    
                const requestResults = response.data;
              
                callback(requestResults);
            })
            .catch((err) => {
                console.log(err);
            })
            
          }

          handleGroupSearch( group){
            this.setState({
                f_expense_group_id: group.value,
            })
        }

    render() {
      
        let expenseTypeList = [];
        
        let paginator;
        if (this.state.hasOwnProperty('expenseTypeList')) {
            expenseTypeList = this.state.expenseTypeList.data;
            paginator = {
                'currentPage':this.state.expenseTypeList.current_page,
                'pagesCount':this.state.expenseTypeList.last_page,
                'total':this.state.expenseTypeList.total,
                'to':this.state.expenseTypeList.to,
                'from':this.state.expenseTypeList.from,
            }
        }

        const {expense_type_id,expense_type_name,expense_type_name_bangla} = this.state.expenseType;

        const getBadge = (status) => {
            return status == 1 ? 'success' : 'secondary'
          }
          
          const getStatusValue = (status) => {
              return status == 1 ? 'Active' : 'In-active'
          }
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid={true}>

                        <Breadcrumbs title="Settings" breadcrumbItem="ExpenseType" />
                        {this.props.error && this.props.error ? <Alert color="danger">{this.props.error}</Alert> : null}
                        {this.props.success && this.props.success ? <Alert color="success">{this.props.success}</Alert> : null}
                        <Row>
                        <Col lg="8" md="8">
                                <Card>
                                    <CardBody>
                                        <CardTitle>ExpenseType List</CardTitle>
                                        <div className="table-responsive-sm">
                                        <DataTabeSearch handleInputChange={this.handleInputChange}/>
                                            <Table className="table  mb-0">

                                                <thead>
                                                    <tr>
                                                        <th>#</th>
                                                        <th>Expense Type Name</th>
                                                        <th>Expense Type Name (Bangla)</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                {expenseTypeList.map((expenseType, index) =>
                                                    <tr key={expenseType.expense_type_id .toString()}>
                                                        <td scope="row">{index+1}</td>
                                                        <td>{expenseType.expense_type_name}</td>
                                                        <td>{expenseType.expense_type_name_bangla}</td>
                                                        <td><button type="button"
                                                               className="btn btn-sm btn-primary waves-effect waves-light"
                                                               onClick={() => { this.tog_scroll(expenseType) }} 
                                                               data-toggle="modal"
                                                             >Edit</button>
                                                            </td>
                                                       </tr>
                                                )}
                                                </tbody>
                                            </Table>
                                        </div>
                                    </CardBody>
                                    {paginator &&
                                     <CardFooter className="p-6">
                                          <CustomPagination paginator={paginator} handlePageClick={this.handlePageClick} />
                                      </CardFooter>
                                      }
                                </Card>
                                <Modal
                                 isOpen={this.state.modal_scroll}
                                   toggle={this.tog_scroll}
                                   scrollable={true}
                                   >
                                   <div className="modal-header">
                                       <h5 className="modal-title mt-0">{expense_type_name}</h5>
                                       <button
                                       type="button"
                                       onClick={() =>
                                           this.setState({ modal_scroll: false })
                                       }
                                       className="close"
                                       data-dismiss="modal"
                                       aria-label="Close"
                                       >
                                       <span aria-hidden="true">&times;</span>
                                       </button>
                                   </div>
                                   <div className="modal-body">
                                   <AvForm className="form-horizontal" onValidSubmit={(e,v) => { this.handleEditSubmit(e,v) }}>
                                       {this.props.msg && this.props.msg ? (
                                           <Alert color="success">
                                               ExpenseType Updated Successfully!
                                           </Alert>
                                           ) : null}
                                                
                                                <div className="col-md-12">
                                                    <AvField className="form-control" label="ExpenseType Name "  type="text" name="expense_type_name" id="expense_type_name" value={expense_type_name} />
                                                     <AvField type="hidden" name="expense_type_id" id="expense_type_id" value={expense_type_id} />
                                                </div>

                                                 <div className="col-md-12">
                                                     <AvField className="form-control" label="ExpenseType Name (Bangla) "  type="text" name="expense_type_name_bangla" id="expense_type_name_bangla" value={expense_type_name_bangla} />
                                                 </div>

                                                 
                                           <div className="text-center mt-4">
                                                <button type="button" className="btn btn-light mr-2" onClick={this.tog_scroll}>Close</button>
                                                <button type="submit" className="btn btn-success save-event">Save</button>
                                           </div>
                                   </AvForm>
                                   </div>
                               </Modal>
                            </Col>
                            <Col lg="4" md="4">
                                <Card>
                                    <CardBody>
                                        <CardTitle>Create New ExpenseType</CardTitle>
                                        
                                        <AvForm className="form-horizontal" onValidSubmit={(e,v) => { this.handleValidSubmit(e,v) }} ref={c => (this.form = c)}>
                                                
                                             
                                                 <div className="col-md-12">
                                                     <AvField className="form-control" label="Expense Type Name "  type="text" name="expense_type_name" id="expense_type_name" />
                                                 </div>

                                                 <div className="col-md-12">
                                                     <AvField className="form-control" label="Expense Type Name (Bangla) "  type="text" name="expense_type_name_bangla" id="expense_type_name_bangla" />
                                                 </div>


                                                 <div className="col-md-12">
                                                        <label>Expense Group</label>
                                                        <AsyncSelect 
                                                            isClearable={true}
                                                            cacheOptions
                                                            isSearchable={true}
                                                            defaultOptions={this.state.expenseGroupList}
                                                            loadOptions={this.loadGroupOptions}
                                                            onChange={(value) => this.handleGroupSearch(value)}
                                                        />
                                                        <FormText style={{background: 'yellow'}}>Search By Expense Group Name </FormText>
                                                        <AvField type="hidden" name="f_expense_group_id" id="f_expense_group_id" value={this.state.f_expense_group_id}/>
                                                 </div>

                                             <div className=" mt-4">
                                                 <Button type="submit" color="success">Submit</Button>
                                             </div>
                                         </AvForm>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        );
    }
}

const mapStatetoProps = state => {
    const { msg,error,success } = state.ExpenseType;
    return { msg,error,success };
}

export default withRouter(connect(mapStatetoProps, { createExpenseType,editExpenseType })(ExpenseTypes));
